import MainOutcomeDescriptionMapper from './main-outcome-description-mapper';

const MainOutcomeDescriptionModel = {
    mapper: MainOutcomeDescriptionMapper,

    id: {
        type: String,
    },

    label: {
        type: String,
    },

    name: {
        type: String,
    },
};

export default MainOutcomeDescriptionModel;
